import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Loader from '../../../shared/Loader/Loader';
import FormValidator from '../../../../utils/FormValidator';
import { enumUtil } from '../../../../utils/Enum';
import NotificationHandler from '../../../../utils/NotificationHandler';
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest';
import isNull from '../../../../utils/NullChecking';
import ModalFooter from '../../Shared/ModalFooter';

const AddNewProgramType = (props) => {
    let { isOpenProgramType, OnClose } = { ...props }
    const API_URL = enumUtil.controller.General

    let ProgramType_Modal = {
        Code: "",
        Description: "",
        FullDescription: "",
    }
    let valModal = {}
    // validation modal 
    let ValidationModal = {
        CodeVal: "",
    }
    const [ProgramTypeValidationModal, setProgramTypeValidationModal] = useState(ValidationModal)
    const [mainProgramTypeModal, setmainProgramTypeModal] = useState(ProgramType_Modal);
    const [ProgramTypeSaveUpdateModal, setProgramTypeSaveUpdateModal] = useState({})

    const [isLoading, setIsLoading] = useState(false)
    const handleProgramTypeChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainProgramTypeModal };
        let saveModal = { ...ProgramTypeSaveUpdateModal }
        modal[name] = value
        setmainProgramTypeModal(modal)
        for (var property in ProgramType_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setProgramTypeSaveUpdateModal(saveModal)
    }
    const ProgramTypeValidation = async () => {
        let ValidationModal = {
            CodeVal: FormValidator(
                mainProgramTypeModal.Code,
                enumUtil.enumValidationType.Required,
                'Code',
            ),

        }
        await setProgramTypeValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleProgramType = async () => {
        // setCategoryTypeCodes(mainProgramTypeModal.Code)
        // setCategoryTypeCodes(CategoryTypeCodes)
        await ProgramTypeValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setProgramTypeSaveUpdateModal(ProgramTypeSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.ProgramType,
                ID: '0',
                data: { ...ProgramTypeSaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    setIsLoading(false)
                    if (!isNull(response.id)) {
                        setProgramTypeSaveUpdateModal("")
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        // setCategoryTypeCodes(response.id)
                        // setOnInsuranceTypeSave(true)
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.warning)
                })
        }
    }
    const SetCategoryTypeName = () => {
        if (mainProgramTypeModal.Code != null && mainProgramTypeModal.Code != "") {
            return (
                <p className="heading">{mainProgramTypeModal.Code}</p>
            )
        } else {
            return (
                <p className="heading">Add New Program Type</p>
            )
        }
    }

    return (
        <Modal show={isOpenProgramType} onHide={OnClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar-small-modal">
            <Modal.Body>
                {isLoading ? <Loader /> : null}
                <div className="d-flex justify-content-between align-items-center mt-2 mb-3 hk-modal-header">
                {SetCategoryTypeName()}
                <button className="btn-icon-transparent" onClick={OnClose}><i className="icon-Icon-metro-cross"></i></button>
                    </div>
                {/* <ModalHeader HeaderName={SetCategoryTypeName}  isClosed={OnClose} key={6361} Name={'Program Type'}  /> */}
                <div>
                    <div className="form-group input">
                        <label htmlFor="Code">Code<span className='req'>*</span></label>
                        <div className={ProgramTypeValidationModal.CodeVal ? 'form-group input error' : 'form-group input'}>
                            <input type="text"
                                className='form-control'
                                name="Code"
                                id="Code"
                                autoComplete="off"
                                value={mainProgramTypeModal.Code}
                                onChange={handleProgramTypeChange}
                            />
                            {ProgramTypeValidationModal.CodeVal}
                        </div>
                        {/* error helperText="Error Message" */}
                    </div>
                    <div className='form-group input'>
                        <label htmlFor="Description">Description</label>
                        <input type="text"
                            className='form-control'
                            name="Description"
                            id="Description"
                            autoComplete="off"
                            value={mainProgramTypeModal.Description}
                            onChange={handleProgramTypeChange}
                        />
                    </div>
                </div>
                <ModalFooter isSaved={OnClose} handleSave={handleProgramType} IsEditAllowed={true} />
            </Modal.Body>
        </Modal>
    )
}

export default AddNewProgramType